import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (context.auth.accessToken !== null) {
      // TODO(media-units): route not yet in route tree — remove cast when route file exists
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw redirect({ to: '/media-units' as any });
    }
    // Unauthenticated users are handled by the root guard which redirects to /login
  },
  component: () => null,
});
